export const steps = [
    {
        id: 1,
        stepTitle: "Наименование проектной активности/кейса/проекта",
    },
    {
        id: 2,
        stepTitle: "Руководитель и\u2009\u2009команда проектной активности (роли в\u2009\u2009команде)",
    },
    {
        id: 3,
        stepTitle: "Описание (презентация) проектной активности/кейса/проекта",
    },
    {
        id: 4,
        stepTitle: "Актуальность проектной активности/кейса/проекта",
    },
    {
        id: 5,
        stepTitle: "Цель проектной активности/кейса/проекта",
    },
    {
        id: 6,
        stepTitle: "Задачи проектной активности/кейса/проекта",
    },
    {
        id: 7,
        stepTitle: "Ожидаемые результаты проектной активности/кейса/проекта",
    },
    {
        id: 8,
        stepTitle: "Наличие успешного опыта/ссылка на\u2009\u2009исследования",
    },
    {
        id: 9,
        stepTitle: "Статус/масштаб проектной активности/кейса/проекта",
    },
    {
        id: 10,
        stepTitle: "География проектной активности/кейса/проекта",
    },
    {
        id: 11,
        stepTitle: "Ресурсы",
    },
    {
        id: 12,
        stepTitle: "План/календарный план",
    },
    {
        id: 13,
        stepTitle: "Бюджет/смета",
    },
    {
        id: 14,
        stepTitle: "Презентация",
    },
    {
        id: 15,
        stepTitle: "Рецензии/итоги/выводы",
    },
]